import React from "react"
import styled from "styled-components";
import { BE_ADDR } from "../../../api/host";

import {LangSelector} from "../../common/LangChanger";

const HeaderLogoImgCenter = styled.img`
  width: ${props => {
    if (props.logoWidth === "" || props.logoWidth === "px") {
      return "70vw"
    }

    return props.logoWidth
  }};
`

const HeaderLogoImgTop = styled.img`
  width: ${props => {
    if (props.logoWidth === "" || props.logoWidth === "px") {
      return '120px'
    }

    return props.logoWidth
  }};
`


const HeaderContainer = ({style}) => {
    return <div>
        {
            style.logo_1_path !== "" && style.logo_1_position === "top" && <HeaderLogoImgTop
                src={`${BE_ADDR}${style.logo_1_path}`}
                logoWidth={style.logo_1_width}
                className='logo-hat-top'
            />
        }
        <div className='d-flex justify-content-end text-end'>
            <LangSelector
                className='d-flex justify-content-end text-end'
                langs={style.lang.split(",")}
            />
        </div>
        {
            style.logo_1_path !== "" && style.logo_1_position === "mid" && <HeaderLogoImgCenter
                src={`${BE_ADDR}${style.logo_1_path}`}
                logoWidth={style.logo_1_width}
                className="logo-hat-center"
            />
        }
    </div>
}

export default HeaderContainer